import { useTranslation } from 'react-i18next';
import { ExternalLinkOutline } from '@styled-icons/evaicons-outline/ExternalLinkOutline';
import 'rc-slider/assets/index.css';
import * as S from './styles';
import { useRouter } from 'next/router';
import { useLine } from 'hooks/use-line';

export const UserInLineModal = () => {
  const router = useRouter();
  const { isUserInLineModalVisible, setIsUserInLineModalVisible } = useLine();
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setIsUserInLineModalVisible(false);
  };

  const handleSeeLinePosition = () => {
    router.push('/my-position');
    setIsUserInLineModalVisible(false);
  };

  return (
    <S.Modal
      width="15%"
      title={
        <S.TitleModalWrapper>
          <S.TitleModal level={1}>{t('@UserInLineModal.title')}</S.TitleModal>
        </S.TitleModalWrapper>
      }
      isOpen={isUserInLineModalVisible}
      onRequestClose={handleCloseModal}
      ariaHideApp={false}
    >
      <S.Body>
        <p className="description">{t('@UserInLineModal.body')}</p>
        <S.Button onClick={handleSeeLinePosition}>
          <div className="content">
            <ExternalLinkOutline size={18} />
            {t('@UserInLineModal.line-position-cta-button')}
          </div>
        </S.Button>
      </S.Body>
    </S.Modal>
  );
};
